import { handleResponseOld, makeGet } from './helpers';

/**
 * @category Auction News API
 * @see fetchNewsItemsBySearchTerm
 */
type FetchNewsItemsBySearchTermParams = {
    deployment: string;
    search: string;
};
/**
 * @category Auction News API
 * @see FetchNewsItemsBySearchTermResponse
 */
export type AuctionNews = {
    blurb: string;
    id: number;
    imgURL: string;
    link: string;
    title: string;
};
/**
 * @category Auction News API
 * @see fetchNewsItemsBySearchTerm
 */
interface FetchNewsItemsBySearchTermResponse {
    error: boolean;
    payload: AuctionNews[];
}

/**
 * Fetches Auction News Items
 * @function fetchNewsItemsBySearchTerm
 * @category Auction News API
 * @param {FetchNewsItemsBySearchTermParams}
 * @returns {FetchNewsItemsBySearchTermResponse}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/acn/news-previews
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/rojyn709l2/resources/fg1ony/methods/GET
 * @see https://github.com/LIVEauctioneers/auction-central-news-api/tree/master/functions/AuctionNewsApi-GetAuctionNews
 */
export const fetchNewsItemsBySearchTerm = ({ deployment, search }: FetchNewsItemsBySearchTermParams) =>
    new Promise<FetchNewsItemsBySearchTermResponse>((resolve, reject) => {
        const request = makeGet({ deployment, path: '<AUCTION-CENTRAL-NEWS-API>news-previews' });
        request.query({ search });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
